import { Breadcrumb } from 'antd';
import React from 'react';

const AdviserAddresss: React.FC = () => (
  <Breadcrumb style={{fontSize:'16px',marginBottom:'11px'}} separator=">">
    <Breadcrumb.Item> {localStorage.getItem("i18nextLng") === 'zh-HK' ? '主頁' : '主页'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '關於我們' : '关于我们'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '顧問委員會' : '顾问委员会'}</Breadcrumb.Item>
  </Breadcrumb>
);

export default AdviserAddresss;
